import { TProductCategory, TProductInstance } from '@lib/core/products/types';
import { TProductRate } from '@lib/core/users/slices/productRate';
import { ILocation } from '@lib/core/users/types';

export const isProductInstanceInWishlistFilter = (
  wishlistProductInstanceIds: string[] = [],
  productInstanceData: TProductInstance,
) => wishlistProductInstanceIds?.includes(productInstanceData?.product?.identifier);

export const isLocationInWishlistFilter = (locationData: ILocation[] = [], locationId: string) =>
  locationData?.some(
    data => data?.retailer_location?.identifier === locationId || data?.retailerLocation?.identifier === locationId,
  );

export const isFeedbackByProductCategory = (feedback: TProductRate, productCategory: TProductCategory): boolean =>
  feedback.product.product.category === productCategory;
